import React from "react";

// Cute owl SVG - our "Gufo" fantavaluta icon
export const GufoIcon = ({ size = 24, className = "" }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden>
    <defs>
      <radialGradient id="gufoBody" cx="50%" cy="50%" r="60%">
        <stop offset="0%" stopColor="#facc15" />
        <stop offset="100%" stopColor="#a16207" />
      </radialGradient>
    </defs>
    <ellipse cx="32" cy="38" rx="22" ry="24" fill="url(#gufoBody)" />
    <path d="M12 20 L20 8 L26 22 Z" fill="#a16207" />
    <path d="M52 20 L44 8 L38 22 Z" fill="#a16207" />
    <circle cx="24" cy="30" r="9" fill="#fff" />
    <circle cx="40" cy="30" r="9" fill="#fff" />
    <circle cx="24" cy="30" r="5" fill="#0a0a0a" />
    <circle cx="40" cy="30" r="5" fill="#0a0a0a" />
    <circle cx="25" cy="28" r="1.6" fill="#fff" />
    <circle cx="41" cy="28" r="1.6" fill="#fff" />
    <path d="M30 36 L32 40 L34 36 Z" fill="#f97316" />
    <path d="M14 50 Q20 46 24 52" stroke="#7c3f00" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d="M50 50 Q44 46 40 52" stroke="#7c3f00" strokeWidth="2" fill="none" strokeLinecap="round" />
  </svg>
);

export default GufoIcon;
